module.exports = __webpack_public_path__ + "img/Ellipse-dark.4b3de9c7.svg";